import { getScrollbarWidth } from "@perxis-auto/shared";
import { createMediaPath } from "../../media/createMediaPath.js";
import { MediaTemplateEnum } from "../../../types/media.js";
const IMAGE_SIZE = {
  preview: [160, 107],
  sm: [640, 427],
  md: [960, 640]
};
const getImageSizes = () => {
  const scrollbarWidth = getScrollbarWidth();
  const sizes = [];
  sizes.push(
    // Ширина картинки занимает ширину экрана без scrollbar минус левые и правые отступы от списка с авто.
    `(max-width: 575px) calc(((100vw - ${scrollbarWidth}px) - 20px - 20px) / 2)`
  );
  return sizes;
};
const formatVehicleModelImage = (marketingMedia, options, template = MediaTemplateEnum.Crop) => {
  const { name: title } = marketingMedia;
  const { media } = options;
  if (!(marketingMedia == null ? void 0 : marketingMedia.file)) {
    return { title };
  }
  const { id } = marketingMedia.file;
  const dpr = window.devicePixelRatio || 1;
  const baseSize = template === MediaTemplateEnum.Crop ? IMAGE_SIZE.sm : IMAGE_SIZE.md;
  const originalParams = {
    width: Math.round(baseSize[0] * dpr),
    height: Math.round(baseSize[1] * dpr),
    crop: `${baseSize[0]},${baseSize[1]}`
    // фиксированный crop
  };
  const original = createMediaPath(id, media, template, originalParams);
  const thumbnail = createMediaPath(id, media, template, {
    width: IMAGE_SIZE.preview[0],
    height: IMAGE_SIZE.preview[1]
  });
  const imageData = {
    title,
    original,
    thumbnail
  };
  if (template === MediaTemplateEnum.Crop) {
    imageData.sizes = getImageSizes().join(",");
    const srcSetWidths = [320, 480, 640, 960, 1800];
    imageData.srcSet = srcSetWidths.map((width) => {
      const height = Math.round(width * 2 / 3);
      return `${createMediaPath(id, media, template, {
        width,
        height,
        crop: `${width},${height}`
      })} ${width}w`;
    }).join(",");
  }
  return imageData;
};
export {
  formatVehicleModelImage
};
